import Vue from 'vue';

export default {
  state: {
    customVariables: null,
    customScriptInfo: {}
  },
  mutations: {
    setCustomVariables(state, payload) {
      state.customVariables = payload;
    },
    addCustomVariable(state, payload) {
      state.customVariables.unshift(payload);
    },
    addCustomScriptInfo(state, payload) {
      Vue.set(state.customScriptInfo, payload?.uuid, payload?.info);
    },
    changeCustomVariable(state, payload) {
      for (let i = 0; i < state.customVariables?.length; i++) {
        if (state.customVariables[i]?.uuid === payload?.uuid) {
          state.customVariables[i] = payload;
          break;
        }
      }
    },
    deleteCustomVariable(state, payload) {
      let deleteIndex = -1;
      for (let i = 0; i < state.customVariables?.length; i++) {
        if (state.customVariables[i]?.uuid === payload) {
          deleteIndex = i;
          break;
        }
      }
      if (deleteIndex !== -1) state.customVariables.splice(deleteIndex, 1);
    }
  },
  actions: {
    setCustomVariables(state, payload) {
      state.commit('setCustomVariables', payload);
    },
    addCustomVariable(state, payload) {
      state.commit('addCustomVariable', payload);
    },
    addCustomScriptInfo(state, payload) {
      state.commit('addCustomScriptInfo', payload);
    },
    changeCustomVariable(state, payload) {
      state.commit('changeCustomVariable', payload);
    },
    deleteCustomVariable(state, payload) {
      state.commit('deleteCustomVariable', payload);
    }
  },
  getters: {
    getCustomVariables(state) {
      return state.customVariables;
    },
    getCustomScriptInfoById: (state) => (uuid) => state.customScriptInfo[uuid] || null
  }
};
